import { render, staticRenderFns } from "./BaseWidget.vue?vue&type=template&id=5bf5b514&scoped=true&"
import script from "./BaseWidget.vue?vue&type=script&lang=js&"
export * from "./BaseWidget.vue?vue&type=script&lang=js&"
import style0 from "./BaseWidget.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BaseWidget.vue?vue&type=style&index=1&id=5bf5b514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf5b514",
  null
  
)

export default component.exports